import { Box } from '@mui/material';
import Loading from 'components/common/Loading';
import isEmpty from 'lodash/isEmpty';
import { node } from 'prop-types';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { useListMessagesQuery, useReadMessagesMutation } from 'store/app/entities/MessagesApiSlice';
import currentChannel from 'store/selectors/currentChannel';
import EmptyChat from './EmptyChat';

const MessagesWrapper = ({ children = null }) => {
  const channel = useSelector(currentChannel);
  const { channelId } = useParams();
  const { state } = useLocation();
  const aroundId = state?.messageId || null;
  const selectedMsgId = useSelector(reduxState => reduxState.elements.ChannelsPanel.messageId);
  const listAroundId = aroundId || selectedMsgId || null;

  const skip = !channelId;
  const { data, isLoading, isSuccess } = useListMessagesQuery(
    {
      channelId,
      ...(listAroundId ? { aroundId: listAroundId } : {}),
    },
    { skip },
  );
  const [readMessagesMutation] = useReadMessagesMutation();

  useEffect(() => {
    if (skip || !isSuccess || !channel?._id || !data?.messages?.length) return;
    const oldest = data.messages[data.messages.length - 1]?._id;
    const newest = data.messages[0]?._id;
    const wouldUpdateFirst =
      !channel.firstReadMessage || (oldest && oldest < channel.firstReadMessage);
    const wouldUpdateLast =
      !channel.lastReadMessage || (newest && newest > channel.lastReadMessage);
    if (wouldUpdateFirst || wouldUpdateLast) {
      readMessagesMutation({ channelId, firstReadMessage: oldest });
    }
  }, [isSuccess, channelId, listAroundId]); // eslint-disable-line react-hooks/exhaustive-deps

  const rootSx = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
    overflow: 'hidden',
  };

  if (!skip && (isLoading || data?.awaitingAroundId)) return <Loading />;

  if (isEmpty(data?.messages)) {
    return (
      <Box sx={rootSx}>
        <EmptyChat />
      </Box>
    );
  }

  return <Box sx={rootSx}>{children}</Box>;
};

MessagesWrapper.propTypes = {
  children: node,
};

export default memo(MessagesWrapper);
